module.exports = __webpack_public_path__ + "media/svg/nf-d0dc5e07.svg";